import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ja from "date-fns/locale/ja";
import type { TenantEditableColumn, TenantItem } from "../../types/tenant";

type DatepickerValidateProps = {
  input: TenantItem;
  column: TenantEditableColumn;
  changedValue: (value: string | null) => void;
};

export default function DatepickerValidate({
  input,
  column,
  changedValue,
}: DatepickerValidateProps) {
  const rawValue = input[column];
  const inputDate = new Date(String(rawValue ?? ""));

  const handleChange = (value: Date | null) => {
    if (value) {
      const selectedDate = value.toLocaleDateString();
      console.log("selectedDate", selectedDate);
      changedValue(selectedDate);
    } else {
      console.log("No date selected");
      changedValue(null);
    }
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={ja}
      dateFormats={{ monthAndYear: "yyyy/MM/dd" }}
      localeText={{
        previousMonth: "前月を表示",
        nextMonth: "次月を表示",
        cancelButtonLabel: "キャンセル",
        okButtonLabel: "選択",
        datePickerToolbarTitle: "日付選択",
      }}
    >
      <DatePicker
        defaultValue={inputDate}
        onChange={handleChange}
        format="yyyy/MM/dd"
        sx={{
          ".MuiInputBase-root": { height: "40px" },
          pointerEvents: "auto",
          width: "100%",
        }}
        slotProps={{
          toolbar: {
            toolbarFormat: "yyyy/MM/dd",
          },
          textField: {
            inputProps: {
              inputMode: "numeric",
              placeholder: "****年**月**日",
            },
          },
        }}
        slots={{
          textField: TextField,
        }}
      />
    </LocalizationProvider>
  );
}
